import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=c0e16792&scoped=true&"
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&lang=less&"
import style1 from "./collection.vue?vue&type=style&index=1&id=c0e16792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e16792",
  null
  
)

export default component.exports